// import { Router, useRouter } from 'next/router';
import { useState } from 'react'
import { ru } from '../data/ru'
import { by } from '../data/by'
import React, { useContext } from 'react';
import Context from '../context'
import API from '../API';
import './feedback.css'
import BtnDelSvg from '../creators/taskCreator/btn-del-svg';


export default function Feedback() {
  let language = localStorage.getItem('lang') === 'ru' ?  ru.feedback : by.feedback
  const defaultFileImgSrc = '';
  const { mainState } = useContext(Context);
  const text = mainState.lang === 'ru' ? ru.feedback : by.feedback;

  const [previewFiles, setPreviewFiles] = useState([]);
  const [state, setState] = useState({
    isAgree: false,
    email: '',
    forWho: '',
    message: '',
  })

  const sendResults = async () => {
    const api = new API();
    await api.sendMessage(state, 'Сообщение успешно отправлено', 'Произошла непредвиденная ошибка')
    setState({
      isAgree: false,
      email: '',
      forWho: '',
      message: '',
    })
  }

  function changeHandler(e) {
    setState(state => {
      return {
        ...state,
        [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value,
      }
    })
  }

  async function submitHandler(e) {
    e.preventDefault();
    await sendResults()
  }

  const preview = previewFiles.map((el, index) => {
    let src = '';
      if (el.type.slice(0, 5) !== 'image') {
        src = defaultFileImgSrc;
      } else {
        src = window.URL.createObjectURL(el);
      }
    return (
      < div className='feedback-media-preview-item' key={index}>
        <img src={src} width={'20%'} alt={'image'}/>
        <div className='feedback-media-preview-name'>{el.name}</div>
        <button className='feedback-media-preview-btn-del' onClick={e => delFile(e, index)}><BtnDelSvg/></button>
      </div>
    )
  });

  const addFile = (e) => {
    let newPFiles = [...previewFiles, e.target.files[0]];
    setPreviewFiles(newPFiles);

  }

  const delFile = (e, id) => {
    e.preventDefault();
    let newPFiles = [];
    previewFiles.map((item, index) => {
      if (index !== id) {
        newPFiles = [...newPFiles, item]
      }
    })
    setPreviewFiles(newPFiles);
  }

  
 // пересмотреть закоменчанную часть
  const agreedData =
    <>
      <input className='feedback-input-box' type="email" placeholder={text.enterEmail} name="email" value={state.email} onChange={(e) => changeHandler(e)} />
      {/*<select className='feedback-input-box' placeholder={text.chooseTopic} name="forWho" onChange={(e) => changeHandler(e)}>*/}
      {/*  <option value="Для администатора">{language.admin}</option>*/}
      {/*  <option value="Для редактора теста">{language.edit}</option>*/}
      {/*  <option value="Для Дениса">{language.denis}</option>*/}
      {/*</select>*/}
      {/*<div className='feedback-media-box'>*/}
      {/*  <label className='feedback-media-btn-add'>*/}
      {/*    <input name='feedbackMedia' className='feedback-media-hidden' type="file" onChange={e => addFile(e)} />*/}
      {/*    {language.addFile}*/}
      {/*  </label>*/}
      {/*</div>*/}
      {/*<div className='feedback-media-preview-box'>*/}
      {/*  {preview}*/}
      {/*</div>*/}
      <textarea className='feedback-input-box' placeholder={text.enterMessage} name="message" value={state.message} onChange={(e) => changeHandler(e)}>{ }</textarea>
      <button className='feedback-button' disabled={!state.isAgree}>{text.send}</button>
    </>

  return (
    <div className='feedback-body'>
      <div className='feedback-container'>
        <div className='feedback-content'>
          <div className="feedback-left-side">
            <div className="feedback-address feedback-details">
              <div className="feedback-topic">{language.address}</div>
              <div className="feedback-text-one">{language.city}</div>
              <div className="feedback-text-two">{language.street}</div>
            </div>
            <div className="feedback-phone feedback-details">
              <div className="feedback-topic">{language.number}</div>
              <div className="feedback-text-one">8-017-250-12-00</div>
              <div className="feedback-text-two">8-017-294-15-94</div>
            </div>
            <div className="feedback-email feedback-details">
              <div className="feedback-topic">Email</div>
              <div className="feedback-text-one">info@giac.by</div>
              <div className="feedback-text-two">info@giac.by</div>
            </div>
          </div>

          <div className='feedback-right-side'>
            <div className='feedback-topic-text'>
              {text.feedbackTitle}
            </div>
            <div className='feedback-rools'>
              {text.rools}
            </div>
            <form onSubmit={(e) => submitHandler(e)} className="feedback-form">
              <label className="feedback-checkbox">
                <input type="checkbox" checked={state.isAgree} name='isAgree' onChange={(e) => changeHandler(e)} />{text.roolsAcceptMessage}
              </label>

              {state.isAgree && agreedData}

            </form>
          </div>
        </div>
      </div>
    </div>
  )
}
